import { useLayoutEffect, useRef, useState } from "react";

const useElementWidth = <T extends HTMLElement>(): [number | undefined, React.RefObject<T>] => {
    const [width, setWidth] = useState<number | undefined>(undefined);
    const elementRef = useRef<T>(null);
  
    useLayoutEffect(() => {
      const handleResize = () => {
        if (elementRef.current) {
          const newWidth = elementRef.current.offsetWidth;
          setWidth(newWidth);
        }
      };
  
      // Initial measurement
      handleResize();
  
      // Add a listener for window resize events
      window.addEventListener('resize', handleResize);
  
      // Clean up the listener when the component unmounts
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);
  
    return [width, elementRef];
}

export default useElementWidth
  